/**
 * duplicateArray
 * @param array to copy
 * @param number of times to duplicate the array
 */
export const duplicateArray = (array, n) => Array.from({
  length: n * array.length
}, (_, i) => array[i % array.length]);

